import { EventRegistrationFormField } from 'src/generated/api/dsv-public/model';

type SpaceFieldProps = {
  field: EventRegistrationFormField;
};

export function SpaceField({ field }: SpaceFieldProps) {
  return (
    <div key={field.key} style={{ height: `${field.options?.height ? Number(field.options.height) * 10 : 0}px` }} />
  );
}
